import { MenuApi as api } from '../api/index'

export default {
  namespaced: true,
  namespace: 'mainmenu',
  state: () => ({
    groups: []
  }),
  actions: {
    async getGroups ({ state }) {
      state.groups = await api.getGroups()
    }
  }
}